module.exports = __webpack_public_path__ + "img/ic_trash.808f2a9f.svg";